<template>
	<div class="rightInner">
		<div class="title">
			<div class="titleLine"></div>
			{{$t('mypages.comments.title')}}
		</div>
		<ul class="tabsArea">
			<li :class="{active: tabIndex == 0}" @click="tabClick(0)">{{$t('mypages.comments.tab_to_comment')}}</li>
			<li :class="{active: tabIndex == 1}" @click="tabClick(1)">{{$t('mypages.comments.tab_commented')}}</li>
		</ul>
		<div>
			<div class="tableHead">
				<div class="infoTh">{{$t('mypages.comments.th_order_detail')}}</div>
				<div class="numTd">{{$t('mypages.comments.th_quantity')}}</div>
				<div class="moneyTd">{{$t('mypages.comments.th_amount')}}</div>
				<div class="userTd">{{$t('mypages.comments.th_recipient')}}</div>
				<div class="toolTd">{{$t('mypages.comments.th_action')}}</div>
			</div>
			<div  v-for="(item,index) in orderList" :key="item.id">			
				<div class="detailTitle">
					{{$t('mypages.comments.platform_order_no')}}{{item.order_no}}    |    {{$t('mypages.comments.purchase_order_no')}}{{item.sale_no}}    |    {{$t('mypages.comments.order_time')}}{{item.gmt_order}}
				</div>
				<table class="orderLists">
					<tr >
						<td rowspan="5">
							<div class="orderlist infoTd" v-for="(detail,index) in item.detail_list" :key="detail.detail_id">
								<div class="orderTitle titleFlex">
								<img  src="../../assets/images/peoImg3.png" />
								<div class="infoDetail ">
									<div class="infoText">{{detail.product_name}}</div>
									<div class="grayText">{{detail.cate_name}}</div>
								</div>
								</div>
								<div class="infolist orderType">
									{{detail.sku_text}}
								</div>	
								<div class="orderAmount numTd">
									<div class="num">{{item.product_count}}</div>
								</div>
								<div class="orderAmount moneyTd">
								<div class="redPrice">￥{{(item.order_amount) }}</div>
								</div>
							</div>
						</td>

						<td rowspan="2">
							<div class="orderStatus userTd">
								<div class="">{{item.receive_name}}</div>
							</div>
						</td>
						<td rowspan="2" v-if="tabIdx==0">
							<div class="orderToolTd toolTd">
								<router-link :to="{path:'/comment',query:{id:item.id}}"><div class="payBtn">{{$t('mypages.comments.btn_review_now')}}</div></router-link>
								<div class="cancelText">{{$t('mypages.comments.btn_order_detail')}}</div>
							</div>
						</td>
						<td rowspan="2" v-else >
								<div class="orderToolTd toolTd">
									<div class="cancelText">{{$t('mypages.comments.text_commented')}}</div>
									<router-link :to="{path:'/appraisal',query:{id:item.id}}"><div class="payBtn">{{$t('mypages.comments.btn_view_review')}}</div> 	</router-link>
									</div>
							</td>
					</tr>				
				</table>
			</div>
			<div class="paginationArea">
				<PaginationVue  :TotalCount="totalcount" :pageSize="10" @pageChenged="handlePage"></PaginationVue>
			</div>
		</div>
	</div>
</template>

<script>
	import PaginationVue from '../../components/pagination.vue';
	export default{	
		props: {
		    tabIdx: {
				type: Number,
				required: true
		    }
		  },
		components:{
			PaginationVue
		},
		data(){
			return {
				orderList:[],
				totalcount:1,
				pageIndex:1,
				tabIndex:0
			}
		},
		created(){
			this.tabIndex=this.tabIdx;
			this.getOrderListInfo();
		},
		watch:{
			tabIdx()
			{
				this.tabIndex=this.tabIdx;
				this.getOrderListInfo();
			}
		},
		methods:{			
			tabClick(idx){
				// this.tabIdx = idx;
				this.tabIndex=idx
				this.getOrderListInfo();
			},
			handlePage(message) {
				console.log(message);
				this.pageIndex = message;
				this.getOrderListInfo();
			},
			getOrderListInfo() {
				this.orderList=[];
				this.$scUtil.axiosPut(this, 'OrderApi/GetOrderPageList', {
					orderNo: '',
					saleNo:'',
					productName:'',
					startTime:'',
					endTime:'',
					userName: localStorage.getItem('username'),
					pageIndex:this.pageIndex,
					pageSize:10,
					status:3,
					evaCount:this.tabIndex
				}, res => {
					if (res.code == 100) {
						this.orderList = res.data;
						this.totalcount=res.totalcount;
						console.log(JSON.stringify(this.orderList));
			
					}		
				});
			},
		},
	}
</script>

<style scoped>
	.rightInner{
		width: 958px;	
	}
	
	
	.title{
		font-size: 14px;
		color: #000000;
		display:flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 20px;
		background-color:#fff;
		background-color: #fff;
	}
	
	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 15px;
	}
	
	ul.tabsArea{
		display: flex;
		align-items: center;
		padding-left: 40px;
		border-bottom: 1px solid #e2e2e2;
		background-color: #fff;
	}
	
	ul.tabsArea li{
		list-style: none;
		margin-right: 60px;
		height: 56px;
		line-height: 56px;
		display: flex;
		align-items: flex-end;
		font-size: 14px;
		color: #666666;
		cursor: pointer;
	}
	
	ul.tabsArea li.active{
		color: #0380fe;
		border-bottom: 2px solid #0380fe;
	} 
	
	.tableHead{
		width: 100%;
		background-color: #fff;
		margin-bottom: 10px;
		height: 45px;
		display: flex;
		align-items: center;
		background-color: #fff;
		font-size: 13px;
	}
	
	.infoTh{
		width: 570px;
		text-align: center;
	}
	
	.infoTd{
		text-align: center;
	}
	
	.numTd{
		width: 37px;
		text-align: center;
	}
	
	.moneyTd{
			width: 115px;
			text-align: center;
	}
	
	.userTd{
		width: 121px;
		text-align: center;
		font-size: 13px;
	}
	
	.detailTitle{
		height: 47px;
		line-height: 47px;
		background-color: #fff;
		padding-left: 20px;
		font-size: 12px;
		color: #333333;
		border-bottom: 1px solid #e2e2e2;
	}
	
	.detailArea{
		background-color: #fff;
	}
	
	.orderlist{
		display: flex;
		align-items: center;		
		padding: 20px 0 20px 0;
		box-sizing: border-box;
		border-bottom: 1px solid #e7e7e7;
	}
	
	.orderlist:nth-last-child(1){
		border-bottom: none;
	}
	
	.infoDetail{
		word-break: break-all;	
	}
	
	.orderlist img{
		width: 79px;
		height: 79px;
		border: 1px solid #e7e7e7;
		margin-right: 15px;
	}
	
	.infoText{
		font-size: 13px;
		color: #000000;
		text-align: left;
		line-height: 25px;
		width: 150px;
	}
	
	.grayText{
		font-size: 12px;
		color: #888888;
		text-align: left;
		line-height: 25px;
	}
	
	.infolist{
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}
	
	.price{
		color: #db050f;
		font-size: 14px;
		font-weight: bolder;
	}
	
	.infolist p{
		width: 100%;
		text-align: left;
	}
	
	.titleFlex{
		display: flex;
		padding-right:30px;
		box-sizing: border-box;
		padding-left: 20px;
	}
	
	.textCenter{
		text-align: center;
	}
	table{
		border-collapse: collapse;
		width: 100%;
		background: #fff;
		margin-bottom: 10px;
	}
	
	table tr td{
		border: 1px solid #e7e7e7;
		border-top: none;
	}
	
	.statusText{
		font-size: 13px;
		color: #333333;
	}
	
	.moreText{
		font-size: 13px;
		color: #0380fe;
		margin-top: 5px;
		cursor: pointer;
	}
	
	.orderToolTd{
		width: 144px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.timeText{
		font-size: 13px;
		color: #333333;
	}
	
	.timeText span{
		font-size: 14px;
		color: #0380fe;
		font-weight: bolder;
	}
	
	.payBtn{
		width: 77px;
		height: 24px;
		border: 1px solid #0380fe;
		color: #0380fe;
		font-size: 12px;
		text-align: center;
		line-height: 24px;
		margin-top: 5px;
		cursor: pointer;
	}
	
	.cancelText{
		font-size: 12px;
		color: #333333;
		margin-top: 5px;
		cursor: pointer;
	}
	
	table tr td:nth-child(1){
		border-left: 0px solid transparent;
	}
	
	table tr td:nth-last-child(1){
		border-right: 0px solid transparent;
	}
	.redPrice{
		font-size: 14px;
		color: #db050f;
	}
	
	.mum{
		font-size: 13px;
		color: #000000;
	}
	
	.statusText{
		font-size: 13px;
		color: #333333;
	}
	
	.moreText{
		font-size: 13px;
		color: #0380fe;
		margin-top: 5px;
		cursor: pointer;
	}
	
	.paginationArea{
		display: flex;
		justify-content: center;
		padding: 17px 0;
	}
	
	.toolTd{
		width:150px;
		text-align: center;
	}
</style>